const translations = {
    flightTime: 'Flight Time'
};

export default translations;
